import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EmployeeProfileComponent } from './employee-profile.component';
import { EmployeeContractualInfosComponent } from './employee-contractual-infos/employee-contractual-infos.component';
import { EmployeeActivitiesComponent } from './employee-activities/employee-activities.component';
import { EmployeeSignaturesComponent } from './employee-signatures/employee-signatures.component';

const routes: Routes = [
  {
    path: '',
    component: EmployeeProfileComponent,
    children: [
      {
        path: '',
        component: EmployeeContractualInfosComponent
      },
      {
        path: 'activities',
        component: EmployeeActivitiesComponent
      },
      {
        path: 'signatures',
        component: EmployeeSignaturesComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeProfileRoutingModule {}
